import styled from 'styled-components'
import themeAsseticonAccountSvg from '@theme/icon/account.svg'

export const IconAcct = styled.i`
  cursor: pointer;
  user-select: none;
  width: 0.5128rem;
  height: 0.5128rem;
  background: url(${themeAsseticonAccountSvg}) no-repeat center;
  background-size: contain;
  margin-right: 0.1025rem;
`
